import React, { useEffect, useState } from 'react';
import {
  Box,
  Flex,
  Input,
  Select,
  Spacer,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import axios from 'axios';
import { DatePicker, DatePickerProps } from 'antd';
import useTable from '../TablePagination/UseTable';
import TablePagination from '../TablePagination/TablePagination';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { FaCheck } from 'react-icons/fa';
import UnlockItemModal from './UnlockItemModal';
dayjs.extend(duration);
interface UserData {
  UserRole: string;
  // Add other properties as needed
}

function TrackingPg() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [status, setStatus] = useState(false);
  const [currentItem, setCurrentItem] = useState<any[]>([]);
  const [trackingResult, setTrackingResult] = useState<any[]>([]);
  const [selectedRegionCode, setSelectedRegionCode] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedFromDate, setSelectedFromDate] = useState(
    dayjs().subtract(3, 'month').format('MM-DD-YYYY')
  );
  const [selectedToDate, setSelectedToDate] = useState(
    dayjs().format('MM-DD-YYYY')
  );
  const dateFormat = 'MM-DD-YYYY';
  const toast = useToast();

  const [currentPage, setCurrentPage] = useState(1);
  const [claimsPerPage, setClaimsPerPage] = useState<number>(10);
  const lastIndex = currentPage * claimsPerPage;
  const firstIndex = lastIndex - claimsPerPage;
  const { slice, range } = useTable(
    trackingResult.length > 0 ? trackingResult : trackingResult,
    currentPage,
    claimsPerPage
  );

  const userdetails: UserData[] = JSON.parse(
    localStorage.getItem('userdetails') || '[]'
  );
  const userRoles: string[] =
    process.env.REACT_APP_USER_ROLES?.split(',') || [];

  const arrregioncodes: string[] = (process.env.REACT_APP_REGION_CODES as string).split(',');

  const trackingResults = async () => {
    try {
      const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
      const tokenUrl = process.env.REACT_APP_TOKEN_URL_SIS as string;
      const validationUrl =
        baseurl +
        '/Validation/Accounts/' +
        selectedFromDate +
        '/' +
        selectedToDate +
        '?status=' +
        selectedStatus +
        '&region=' +
        selectedRegionCode;

      const tokenResponse = await axios.get(tokenUrl);
      if (tokenResponse.data.success) {
        const validationResponse = await axios.get(validationUrl, {
          headers: {
            Pragma: 'no-cache',
            Authorization: 'Bearer ' + tokenResponse.data.token,
          },
        });
        if (validationResponse.data.success) {
          const filteredData = validationResponse.data.result.filter(
            (item: any) =>
              [
                item.accountNo,
                item.RegionCode,
                item.lockedBy,
                item.trackingNo,
                item.lockedOn,
                item.validatedOn,
                item.validationRemarks,
                item.validationStatus,
              ].some(
                value =>
                  value &&
                  value.toLowerCase().includes(searchQuery.toLowerCase())
              )
          );
          setTrackingResult(filteredData);
        } else {
          throw new Error('Failed to fetch validation data');
        }
      } else {
        throw new Error('Failed to retrieve auth token');
      }
    } catch (error) {
      console.error('Error fetching validation data:', error);
    }
  };

  useEffect(() => {
    trackingResults();
  }, [
    selectedFromDate,
    selectedToDate,
    selectedRegionCode,
    selectedStatus,
    searchQuery,
    status,
  ]);

  const handleRegionCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedRegionCode(e.target.value);
  };
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedStatus(e.target.value);
  };

  const handleFromDateChange = (
    date: dayjs.Dayjs | null,
    dateString: string | string[]
  ) => {
    if (date && typeof dateString === 'string') {
      const formattedDate = dayjs(date).format(dateFormat);
      setSelectedFromDate(formattedDate);
    }
  };

  const handleToDateChange = (
    date: dayjs.Dayjs | null,
    dateString: string | string[]
  ) => {
    if (date && typeof dateString === 'string') {
      const formattedDate = dayjs(date).format(dateFormat);
      setSelectedToDate(formattedDate);
    }
  };
  function calculateTimeDifference(lockedOn: any, validatedOn: any) {
    const lockedOnTime = dayjs(lockedOn);
    const validatedOnTime = dayjs(validatedOn);

    const duration = dayjs.duration(validatedOnTime.diff(lockedOnTime));
    return duration;
  }

  const disabledFromToday: DatePickerProps['disabledDate'] = current => {
    const today = dayjs().format('MM-DD-YYYY');
    return !current.isBefore(today);
  };

  const disabledFromTomorrow: DatePickerProps['disabledDate'] = (
    current,
    { from }
  ) => {
    const tomorrow = dayjs().add(1, 'day').format('MM-DD-YYYY');
    return !current.isBefore(tomorrow);
  };

  return (
    <>
      <Box display=" flex" flexDirection="column">
        <Flex display="flex" justifyContent="flex-start" flexDir="row">
          <Text pt="2px" mr="5px" fontWeight="bold">
            Region:
          </Text>
          <Select
            isRequired
            value={selectedRegionCode}
            onChange={handleRegionCodeChange}
            mr="10px"
            placeholder="ALL"
            size="sm"
            width="150px"
            mb="5px"
            borderRadius="10px"
            border="1px solid #d3d3d3"
          >
            {arrregioncodes?.map(regioncode => (
                <option key={regioncode} value={regioncode}>
                  {regioncode}
                </option>
              ))}
          </Select>
          <Text pt="2px" mr="5px" fontWeight="bold">
            Status:
          </Text>
          <Select
            value={selectedStatus}
            onChange={handleStatusChange}
            mr="10px"
            placeholder="ALL"
            size="sm"
            width="150px"
            mb="5px"
            borderRadius="10px"
            border="1px solid #d3d3d3"
          >
            <option value="New">New</option>
            <option value="Success">Success</option>
            <option value="Failed">Failed</option>
          </Select>
          <Text pt="2px" mr="5px" fontWeight="bold">
            From:
          </Text>
          <Box mr="10px">
            <DatePicker
              value={dayjs(selectedFromDate, dateFormat)}
              format={dateFormat}
              onChange={handleFromDateChange}
              disabledDate={disabledFromToday}
            />
          </Box>
          <Text pt="2px" mr="5px" fontWeight="bold">
            To:
          </Text>
          <Box mr="10px">
            <DatePicker
              value={dayjs(selectedToDate, dateFormat)}
              format={dateFormat}
              onChange={handleToDateChange}
              disabledDate={disabledFromTomorrow}
            />
          </Box>
          <Input
            marginBottom="5px"
            marginTop="15px"
            htmlSize={24}
            width="auto"
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            marginLeft="auto" // Add this line
          />
        </Flex>
        <TableContainer borderRadius="5px" borderTopColor="black">
          <Table
            variant="striped"
            colorScheme="blackAlpha"
            size="sm"
            overflow="auto"
          >
            <Thead bgColor="#002677">
              <Tr>
                <Th color="white">Region</Th>
                <Th color="white">Account No</Th>
                <Th color="white">Tracking No</Th>
                <Th color="white">Status</Th>
                <Th color="white">Health Plan Name</Th>
                <Th color="white">Hospital Name</Th>
                <Th color="white">Plan Type</Th>
                <Th color="white">Delivery Option</Th>
                <Th color="white">Locked By</Th>
                <Th color="white">Locked On</Th>
                <Th color="white">Validated on</Th>
                <Th color="white">handling time</Th>
                <Th color="white">Comment</Th>
                <Th color="white" isNumeric>
                  Unlock
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {trackingResult.slice(firstIndex, lastIndex).map(item => (
                <Tr
                  key={item.accountNo}
                  bg={item.validatedOn == null ? 'red' : 'none'}
                >
                  <Td>{item.RegionCode}</Td>
                  <Td>{item.accountNo}</Td>
                  <Td>{item.trackingNo}</Td>
                  <Td
                    color={
                      item.validationStatus === 'Success'
                        ? 'green'
                        : item.validationStatus === 'Failed'
                        ? 'red'
                        : 'orange'
                    }
                  >
                    {item.validationStatus}
                  </Td>

                  <Td>
                    {item.HealthPlanName ? (
                      <Tooltip
                        bg="#002677"
                        color="white"
                        label={item.HealthPlanName}
                        aria-label="healh-plan-name"
                        placement="left-start"
                        hasArrow
                        arrowSize={10}
                      >
                        {item.HealthPlanName.length > 15
                          ? `${item.HealthPlanName.slice(0, 15)} ...`
                          : item.HealthPlanName}
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </Td>
                  <Td>
                    {item.HospitalName ? (
                      <Tooltip
                        bg="#002677"
                        color="white"
                        label={item.HospitalName}
                        aria-label="hospital-name"
                        placement="left-start"
                        hasArrow
                        arrowSize={10}
                      >
                        {item.HospitalName.length > 12
                          ? `${item.HospitalName.slice(0, 12)} ...`
                          : item.HospitalName}
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </Td>
                  <Td>
                    {item.PlanType ? (
                      <Tooltip
                        bg="#002677"
                        color="white"
                        label={item.PlanType}
                        aria-label="plan-type"
                        placement="left-start"
                        hasArrow
                        arrowSize={10}
                      >
                        {item.PlanType.length > 10
                          ? `${item.PlanType.slice(0, 10)} ...`
                          : item.PlanType}
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </Td>
                  <Td>{item.deliveryoption}</Td>
                  <Td>
                    {item.lockedBy ? (
                      <Tooltip
                        bg="#002677"
                        color="white"
                        label={item.lockedBy}
                        aria-label="locked-by"
                        placement="left-start"
                        hasArrow
                        arrowSize={10}
                      >
                        {item.lockedBy.includes('@')
                          ? item.lockedBy.split('@')[0]
                          : item.lockedBy}
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </Td>
                  <Td>
                    {item.lockedOn ? (
                      <Tooltip
                        bg="#002677"
                        color="white"
                        label={new Date(item.lockedOn)
                          .toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                          })
                          .replace(/\//g, '-')}
                        aria-label="validated-on"
                        placement="left-start"
                        hasArrow
                        arrowSize={10}
                      >
                        {item.lockedOn
                          ? new Date(item.lockedOn)
                              .toLocaleDateString()
                              .replace(/\//g, '-')
                          : ''}
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </Td>

                  <Td>
                    {item.validatedOn ? (
                      <Tooltip
                        bg="#002677"
                        color="white"
                        label={new Date(item.validatedOn)
                          .toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            second: '2-digit',
                          })
                          .replace(/\//g, '-')}
                        aria-label="validated-on"
                        placement="left-start"
                        hasArrow
                        arrowSize={10}
                      >
                        {item.validatedOn
                          ? new Date(item.validatedOn)
                              .toLocaleDateString()
                              .replace(/\//g, '-')
                          : ''}
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </Td>
                  <Td>
                    {item.lockedOn && item.validatedOn ? (
                      <>
                        {calculateTimeDifference(
                          item.lockedOn,
                          item.validatedOn
                        ).days() *
                          24 +
                          calculateTimeDifference(
                            item.lockedOn,
                            item.validatedOn
                          ).hours()}
                        h {''}
                        {calculateTimeDifference(
                          item.lockedOn,
                          item.validatedOn
                        ).minutes()}
                        min
                      </>
                    ) : (
                      <>
                        {calculateTimeDifference(
                          item.lockedOn,
                          new Date()
                        ).days() *
                          24 +
                          calculateTimeDifference(
                            item.lockedOn,
                            new Date()
                          ).hours()}
                        h {''}
                        {calculateTimeDifference(
                          item.lockedOn,
                          new Date()
                        ).minutes()}
                        min
                      </>
                    )}
                  </Td>

                  <Td>
                    {item.validationRemarks ? (
                      <Tooltip
                        bg="#002677"
                        color="white"
                        label={item.validationRemarks}
                        aria-label="validation-remarks"
                        placement="left-start"
                        hasArrow
                        arrowSize={10}
                      >
                        {item.validationRemarks.length > 15
                          ? `${item.validationRemarks.slice(0, 15)} ...`
                          : item.validationRemarks}
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </Td>
                  <Td pt="0" pb="0" mt="0" mb="0" pr="35px" isNumeric>
                    <Flex justifyContent="flex-end">
                      <FaCheck
                        onClick={() => {
                          if (
                            !item.validatedOn ||
                            userRoles.includes(userdetails[0]?.UserRole)
                          ) {
                            onOpen();
                            setCurrentItem(item);
                            setStatus(true);
                          } else {
                            toast({
                              title: 'Permission denied',
                              position: 'top',
                              description:
                                'This Item was already validated by: ' +
                                item.lockedBy,
                              status: 'error',
                              duration: 9000,
                              isClosable: true,
                            });
                          }
                        }}
                      />
                    </Flex>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
          <Flex display="flex" flexDirection="row">
            <Flex />
            <Spacer />
            <TablePagination
              range={range}
              slice={slice}
              setPage={setCurrentPage}
              page={currentPage}
            />
            <Spacer />
            <Select
              value={claimsPerPage}
              onChange={e => setClaimsPerPage(parseInt(e.target.value))}
              width="100px"
              height="30px"
              mt="5px"
              mr="5px"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </Select>
          </Flex>
        </TableContainer>
      </Box>

      <UnlockItemModal
        isOpen={isOpen}
        onClose={onClose}
        currentItem={currentItem}
        setStatus={setStatus}
      />
    </>
  );
}

export default TrackingPg;
